import axios from 'axios';
import { getToken } from '@/utils/auth';
import router from '@/router';
import env from '@/utils/env';
import { Message } from 'element-ui';

// 创建 Axios 实例
const service = axios.create({
  baseURL: env.baseURL, // 设置 API 的基础 URL
  // timeout: 5000, // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
  config => {
    if (getToken()) {
      config.headers['token'] = getToken();
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;

    // 处理业务逻辑错误
    if (res.code === 401) {
      handleUnauthorized();
      return res
    } else if (res.code === 0) {
      Message.error(res.msg || '请输入必传参数');
      return res
    } else {
      return res;
    }
  },
  error => {
    // 处理 HTTP 错误状态码
    if (error.response) {
      switch (error.response.status) {
        case 401:
          handleUnauthorized();
          break;
        case 403:
          Message.error('无权访问');
          break;
        case 404:
          Message.error('资源不存在');
          break;
        case 500:
          Message.error('服务器错误');
          break;
        default:
          Message.error(error.msg || '请求失败');
      }
    }
    return error;
  }
);
function handleUnauthorized() {
  localStorage.removeItem('token');
  localStorage.clear();
  Message.warning('登录失效，请重新登录！');
  setTimeout(() => {
    if (router.currentRoute.path !== '/login') {
      router.push('/login');
    }
  }, 1000);
}

export default service;